import React, { useState } from 'react';

import { Box, List } from '@mui/material';

import { Column } from 'api/shared/models';

import { styles } from '../styles';

import OptionDragAndDrop from './OptionDragAndDrop';
import Option from './Option';

interface Props {
  columns: Column[];
  addDragAndDrop?: boolean;
  onClick: (column: Column) => void;
  moveRows?: (rowIndex: number, newIndex: number) => void;
  handleSort?: (column: Column) => void;
}

const ColumnOptions = ({
  columns,
  onClick,
  addDragAndDrop,
  moveRows,
  handleSort,
}: Props) => {
  const [indexTarget, setIndexTarget] = useState<number | null>(null);

  return (
    <Box sx={styles.rootOptions}>
      <List>
        {columns.map((column, index) => (
          <React.Fragment key={index}>
            {addDragAndDrop ? (
              <OptionDragAndDrop
                index={index}
                column={column}
                onClick={onClick}
                indexTarget={indexTarget}
                setIndexTarget={setIndexTarget}
                moveRows={moveRows}
                handleSort={handleSort}
              />
            ) : (
              <Option column={column} onClick={onClick} />
            )}
          </React.Fragment>
        ))}
      </List>
    </Box>
  );
};

export default ColumnOptions;
